// Centralised Hungarian language file for UI text in Weather App
// Please keep keys in sync with en.ts for consistency

const hu = {
  app: {
    title: 'WeatherUp!',
    welcome: 'Üdvözöljük a WeatherUp-on! 🌤️',
    subtitle: 'Világ Időjárás',
    instructions: 'Írjon be egy városnevet az időjárás ellenőrzéséhez és a jelenlegi körülményekről való tájékozódáshoz. Kezdje el a fenti keresőmezőbe írni. Jó böngészést!'
  },
  weather: {
    loading: 'Időjárási adatok betöltése...',
    cardTitle: 'Időjárás itt:',
    currentTemp: 'Jelenlegi Hőmérséklet',
    min: 'Min:',
    max: 'Max:',
    localTime: 'Helyi Idő',
    details: 'Időjárási Részletek',
    humidity: 'Páratartalom',
    pressure: 'Légnyomás',
    windSpeed: 'Szélsebesség',
    visibility: 'Láthatóság',
    feelsLike: 'Hőérzet',
  },
  search: {
    placeholder: 'Város keresése...',
    ariaLabel: 'Város keresése',
    button: 'Keresés',
    noResults: 'Nem található helyszín.'
  }
};

export default hu;
